module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"step":"questions list","back":"Back","next":"Next","end":"Complete","returnToTemplates":"Go back to the Template Selection Wizard"}}')
  delete Component.options._Ctor
}
